import { API_ENDPOINTS } from '@/constants/api';
import { useEntityForm } from '@/shared/hooks/useEntityForm';
import { useAppDispatch } from '@/shared/hooks';
import { useErrorHandler } from '@/shared/hooks/useErrorHandler';
import { useSuccessMessage } from '@/shared/hooks/useSuccessMessage';
import { useNavigate } from 'react-router-dom';
import { rolesApi } from '../api';
import { createRole, updateRole } from '../store/entitySlice';
import type { Role, RoleData } from '../types';

export const useRoleForm = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { showSuccess } = useSuccessMessage();
  const { error, handleError, clearError } = useErrorHandler();
  const form = useEntityForm<Role, RoleData>({
    api: rolesApi,
    createAction: createRole,
    updateAction: updateRole,
    listEndpoint: API_ENDPOINTS.ROLES.LIST,
    entityName: 'Role',
  });

  const handleSubmit = async (data: RoleData) => {
    if (form.isEdit) {
      return form.handleSubmit(data);
    }
    clearError();
    try {
      await dispatch(createRole(data)).unwrap();
      showSuccess('Role created successfully!');
      void navigate('/users/roles');
    } catch (err) {
      handleError(err);
    }
  };

  return { ...form, error: error || form.error, handleSubmit };
};
